import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const AccountAsync = lazy(() => import('./ui/Account'));

export const Account = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <AccountAsync />
    </Suspense>
  );
};
